<script setup>
import { computed } from 'vue';
import BaseNode from './BaseNode.vue';
import OutputRow from './OutputRow.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const rows = computed(() =>
  (props.data.config?.sections || []).flatMap(section => section.rows || [])
);
</script>

<template>
  <BaseNode
    type="whatsapp_list"
    :title="data.title"
    :selected="selected"
    :has-error="!(data.config && data.config.body) || !rows.length"
  >
    <p class="mb-1 whitespace-pre-line line-clamp-2">
      {{ data.config?.body || $t('FLOWS.BUILDER.CANVAS.EMPTY_TEXT') }}
    </p>
    <div class="border-t border-n-weak pt-1">
      <OutputRow
        v-for="row in rows"
        :key="row.id"
        :handle-id="`row-${row.id}`"
        :label="row.title || row.id"
      />
      <OutputRow handle-id="fallback" :label="$t('FLOWS.BUILDER.CANVAS.FALLBACK_OUTPUT')" muted />
    </div>
  </BaseNode>
</template>
